import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { withStyles } from '@mui/styles';
import Logo from '../../../../src/Icons/knsLogoFullNameBg.png';
import { withRouter } from 'react-router-dom'; // ✅ only available in React Router v5

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f0f0f0',
  },
  card: {
    maxWidth: 400,
    width: '100%',
    backgroundColor: 'white',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    padding: 32,
    textAlign: 'center',
  },
  logo: {
    marginBottom: 16,
    height: 100,
    width: 'auto',
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 20,
  },
  button: {
    marginTop: 16,
  },
};

class ThankYouPage extends Component {
  handleKnowMoreClick = () => {
    this.props.history.push('/login'); // ✅ using this.props.history
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <img src={Logo} alt="Logo" className={classes.logo} />
        <h2 className={classes.heading}>Registered Successfully!</h2>
        <p className="text-gray-600 mb-6">Thank you for your Registering.</p>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleKnowMoreClick}
          className={classes.button}
        >
          Click here to Login 
        </Button>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(ThankYouPage));
